const serverEnvironment = "serverless";  // change to serverless before commiting
const switchAPI = serverEnvironment === "local" ? "http://localhost:8888/api" : "https://atserverless.netlify.app/api"

export default switchAPI;